var _ = require('lodash');

var _require = require('./childValidation'),
    validationType = _require.validationType;

var buildValidationError = function buildValidationError(compositeName, childrenTypes) {
  if (childrenTypes.validation === validationType.ANY) {
    return;
  }

  var types = _.map(childrenTypes, function (c) {
    return "".concat(c.names.join('/'), " (").concat(c.validation, ")");
  });

  return new Error("".concat(compositeName, " should have children of the following types in this order: ").concat(types.join(', '), "."));
};

module.exports = {
  buildValidationError: buildValidationError
};